const { query, nullToUndefined } = require('@simpleview/sv-graphql-client');

class DamPrefix {
	constructor({ graphUrl, graphServer }) {
		this.name = 'dam';
		this._graphUrl = graphUrl;
		this._graphServer = graphServer;
	};

	async assets_upsert({ input, fields, context }) {
		const variables = { 
			acct_id: context.acct_id, 
			input
		};

		const response = await query({
			query:`
				mutation(
					$acct_id: String!, 
					$input: dam_assets_upsert!
				) {
					dam(acct_id: $acct_id) {
						assets_upsert(input: $input) {
							${fields}
						}
					}
				}
			`,
			variables,
			url: this._graphUrl,
			token: context.token
		});

		return response.dam.assets_upsert;
	};

	async assets({ filter, options, fields, context }) {
		context = context || this._graphServer.context;
		const variables = { 
			acct_id: context.acct_id,
			filter,
			options
		};

		const response = await query({
			query:`
				query(
					$acct_id: String!, 
					$filter: dam_assets_filter,
					$options: dam_options 
				) {
					dam(acct_id: $acct_id) {
						assets(
							filter: $filter, 
							options: $options
						){
							${fields}
						}
					}
				}
			`,
			variables,
			url: this._graphUrl,
			token: context.token
		});

		return response.dam.assets;
	};

	async assets_remove({ filter, fields, context }) {
		context = context || this._graphServer.context;
		const variables = { 
			acct_id: context.acct_id, 
			filter 
		};

		const response = await query({
			query: `
				mutation(
					$acct_id: String!, 
					$filter: dam_assets_remove_filter!
				) {
					dam(acct_id: $acct_id) {
						assets_remove(filter: $filter) {
							${fields}
						}
					}
				}
			`,
			variables,
			url: this._graphUrl,
			token: context.token
		});

		return response.dam.assets_remove;
	};
}

module.exports = DamPrefix;
